import {YesNoFormValue, type KilnCheckSheetCoolerSectionFormValues} from '../../../types'

export const coolerSectionDefaultValues: KilnCheckSheetCoolerSectionFormValues = {
  compartmentsNormal: '',
  compartmentsFull: '',
  compartmentsNormalRetake: '',
  compartmentsFullRetake: '',
  compartmentsComment: '',

  gratesNormal: '',
  gratesMissing: '',
  gratesNormalRetake: '',
  gratesMissingRetake: '',
  gratesComment: '',

  coolerDrivesOperatingProperly: {
    value: YesNoFormValue.YES,
    valueRetake: YesNoFormValue.YES,
    comment: ''
  },
  coolerDrives3ShotsGrease: {
    value: YesNoFormValue.YES,
    valueRetake: YesNoFormValue.YES,
    comment: ''
  },
  megaBlastersOperatingProperly: {
    value: YesNoFormValue.YES,
    valueRetake: YesNoFormValue.YES,
    comment: ''
  },
  undergrateFans1To8OperatingProperly: {value: YesNoFormValue.YES, comment: ''},
  clinkerBreakerBeltsBearingsMotorOperatingProperly: {value: YesNoFormValue.YES, comment: ''},
  plattcoValvesOperatingProperly: {value: YesNoFormValue.YES, comment: ''},
  plattcoValvesAnyLeftOpen: {value: YesNoFormValue.YES, comment: ''},
  finesDrags6119And6120OperatingProperly: {value: YesNoFormValue.YES, comment: ''},
  panConveyorEastPanOperatingProperly: {value: YesNoFormValue.YES, comment: ''},
  panConveyorEastPanExcessiveSpillage: {value: YesNoFormValue.YES, comment: ''},
  panConveyorEastPanPansNormal: '',
  panConveyorEastPanPansDamaged: '',
  panConveyorEastPanPansComment: ''
}
